import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DirectivesModule } from 'app/directives/directives.module';
import { AdministrationRoutingModule } from './administration-routing.module';
import { PriorityComponent } from './reservations/priority/priority.component';
import { NatureComponent } from './reservations/nature/nature.component';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';
import { AgGridModule } from 'ag-grid-angular';
import { ManageNatureComponent } from './reservations/nature/components/manage-nature/manage-nature.component';
import { ManagePriorityComponent } from './reservations/priority/components/manage-priority/manage-priority.component';

import { PriorityService } from './../../services/administration/priority.service';
import { NatureService } from './../../services/administration/nature.service';
import { ConfigurationComponent } from './configuration/configuration.component';
import { ConfigurationService } from './../../services/administration/configuration.service';
import { BackgroundChecksModule } from "./fleet/background-checks/background-checks.module";

import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  imports: [
    CommonModule,
    AdministrationRoutingModule,
    Trip2ThemeModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    BackgroundChecksModule,
    AngularMultiSelectModule
  ],
  declarations: [PriorityComponent, NatureComponent, ManageNatureComponent, ManagePriorityComponent, ConfigurationComponent],
  providers: [
    NatureService,
    PriorityService,
    ConfigurationService
  ]
})
export class AdministrationModule { }



// WEBPACK FOOTER //
// ./src/app/pages/administration/administration.module.ts